import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {WarningButton, DefaultButton} from "../../../components";

const Controls = styled.div`
  display: inline-flex;
  width: 100%;
  margin: 1em 0;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;  
`;

class FormControls extends React.Component {

  noop = () => {
  };
  waitForAction =  (action, after) => async () => {
    await action();
    (after || this.noop)();
  };

  saveButtons;


  render() {
    const {disabled, onClose, onSave, onSubmit, onSetToInProgress, completeText, enableComplete, showSave, onCompleteClose, showSetToInProgress, showComplete, showIrrSave, onIrrSave, afterIrrSave} = this.props;
    let saveButtons = null;
    let completeButton = null;
    let irrSaveButton = null;
    if (showSave) {
      saveButtons = 
      <React.Fragment>
        <WarningButton disabled={disabled} onClick={this.waitForAction(onSave)}>Save</WarningButton>
        <WarningButton disabled={disabled} onClick={this.waitForAction(onSave, onClose)}>Save & Close</WarningButton>
        
      </React.Fragment>;
    }
     
    if (showComplete) {
      completeButton = 
      <React.Fragment>
        <WarningButton
            disabled={disabled || !enableComplete}
            onClick={this.waitForAction(onSubmit, onCompleteClose)}
          >
            {completeText}
          </WarningButton>
      </React.Fragment>
    }

    if (showIrrSave) {
      irrSaveButton = 
      <React.Fragment>
        <WarningButton onClick={this.waitForAction(onIrrSave, afterIrrSave)}>Save IRR</WarningButton>
        <div />
      </React.Fragment>
    }

    return (
      <Controls>
        <Container>
          <DefaultButton onClick={onClose}>Close</DefaultButton>
          {saveButtons}
          {completeButton}
          {showSetToInProgress && <WarningButton onClick={this.waitForAction(onSetToInProgress)}>Set to In Progress</WarningButton>}
          {irrSaveButton}
        </Container>
      </Controls>
    );

  }
}

FormControls.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCompleteClose: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSetToInProgress: PropTypes.func,
  onIrrSave: PropTypes.func.isRequired,
  afterIrrSave: PropTypes.func.isRequired,
  enableComplete: PropTypes.bool.isRequired,
  completeText: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  showSave: PropTypes.bool,
  showComplete: PropTypes.bool,
  showSetToInProgress: PropTypes.bool,
  showIrrSave: PropTypes.bool
};

FormControls.defaultProps = {
  showSave: false,
  showSetToInProgress: false,
  showComplete: false
};

export default FormControls;



// WEBPACK FOOTER //
// ./src/modules/record/components/FormControls.js